import React from 'react'
import { Search } from 'react-feather'
import Dropdown from 'react-dropdown';
import './dropdown.css';
import { ChevronDown } from 'react-feather'
// import { Link } from 'react-router-dom';
import copy from '../../../database/pages/home.json'

// const options = [
//   'FOR EVERYONE',
//   'FOR PRACTITIONER', 'FOR EDUCATOR',
//   'FOR POLICY MAKER',
//   'FOR RESEARCHER', 'FOR DONOR'
// ];
// const defaultOption = options[0];

const options2 = [
  'Kebijakan Nasional/Daerah',
  'Kebijakan Internasional',
  'Hasil Penelitian',
  'Buku & Modul',
  'Instrumen & Panduan',
  'Kasus',
  'Inisiatif',
  'Blog',
  'Event'
]

const options3 = [
  'Pencegahan',
  'Penegakan Hukum dan Penguatan Kerangka Legislasi Nasional',
  'Kemitraan dan Kerja Sama Internasional'
];

// const RoleDropdown = () => {
//   const handleChange = (e) => {
//     console.log(e)
//   }

//   return (
//     <div className="items-center justify-center flex relative">
//       <div className="flex items-center cursor-pointer">
//         <ChevronDown
//           style={{width: '16px', height: '16px', color: '#52BAE2'}}
//           className="mr-2"
//         />
//         <Dropdown
//           options={options}
//           onChange={handleChange}
//           value={defaultOption}
//           placeholder="Select an option"
//           className="header-dropdown"
//         />
//       </div>
//     </div>
//   )
// }

const CustomDropdown = ({placeholder, options}) => {
  const handleChange = (e) => {
    console.log(e)
  }

  return (
    <div className="h-full w-full bg-transparent cursor-pointer text-sm flex items-center w-full">
      <div className="flex items-center cursor-pointer w-full">
        <ChevronDown
          style={{width: '16px', height: '16px', color: '#999'}}
          className="absolute w-full"
        />
        <Dropdown
          options={options}
          onChange={handleChange}
          // value={defaultOption}
          placeholder={placeholder}
        />
      </div>
    </div>
  )
}

const Filter = () => {
  return (
    <div className="lg:w-8/12 mx-auto">
      <div className="flex justify-between">
        <div className="flex rounded rounded-r-none border w-full bg-white" style={{borderColor: '#ddd', borderWidth: '2px', borderRightWidth: '0px'}}>
          <div className="w-1/3 md:hidden pl-2 border-r-2" style={{borderColor: '#ddd'}}>
            <CustomDropdown placeholder="Filter" options={options3}/>
          </div>
          <div className="w-2/3 md:w-1/3">
            <input type="text" className="input bg-transparent w-full h-full px-4 text-sm" placeholder="What I want to know..." style={{fontFamily: "'Lato', sans-serif"}}/>
          </div>
          <div className="w-2/3 justify-between items-center hidden md:flex lg:flex">
            <div style={{width: '50%'}}>
              <CustomDropdown placeholder="by Knowledge Product" options={options2}/>
            </div>
            <div style={{width: '50%'}}>
              <CustomDropdown placeholder="by Approach" options={options3}/>
            </div>
          </div>
        </div>
        <div className="rounded rounded-l-none text-white flex items-center justify-center" style={{background: '#DA251D'}}>
          {/* <Link to="/search-results"> */}
            <button className="p-3 lg:p-4">
              <Search className="hero__search-icon"/>
            </button>
          {/* </Link> */}
        </div>
      </div>
    </div>
  )
}

const Hero = () => {
  return (
    <div
      className="bg-cover bg-center bg-no-repeat relative min-h-screen flex items-center justify-center"
      style={{backgroundImage: `url('/images/bnpt-hero-background.jpg')`}}
    >
      <div className="absolute w-full h-full bg-black opacity-50 left-0 top-0"></div>
      <div className="hero container mx-auto relative z-10">
        <div className="lg:w-8/12 mx-auto text-center mb-8 lg:mb-10">
          {/* <div className="md:hidden mx-auto mb-3">
            <RoleDropdown />
          </div> */}
          <p className="hero__title font-bold mb-3 text-white">
            {copy.atf}
          </p>
        </div>
        <Filter />
      </div>
    </div>
  )
}

export { Hero }
